export default "__VITE_ASSET__BTbIZdE3__"